import type { Locale } from '../i18n/config';

export const isGenAiLogomakerAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = [
        'en-US',
        'en-CA',
        'en-GB',
        'en-AU',
        'en-IE',
        'en-NZ',
        'en-SG',
    ];
    return availableLocales.includes(locale);
};
